import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Section = styled.section`
  padding: 6rem 6%;
  background-color: white;
  
  @media (max-width: 768px) {
    padding: 4rem 6%;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 3rem;
  text-align: center;
  color: #000;
  position: relative;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 2px;
    background-color: #000;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const PricingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2.5rem;
  margin-top: 3rem;
  max-width: 1000px;
  margin: 0 auto;
`;

const PricingCard = styled(motion.div)`
  padding: 3rem 2.5rem;
  border-radius: 12px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, ${props => props.featured ? '0.1' : '0.05'});
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${props => props.featured ? '#000' : 'white'};
  color: ${props => props.featured ? 'white' : 'inherit'};
  position: relative;
  overflow: hidden;
  border: 1px solid ${props => props.featured ? '#000' : '#f0f0f0'};
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, ${props => props.featured ? '0.2' : '0.1'});
  }
  
  ${props => props.featured && `
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      height: 100px;
      background-color: rgba(255, 255, 255, 0.05);
      border-radius: 0 0 0 100%;
    }
  `}
`;

const PricingTitle = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  color: ${props => props.white ? 'white' : '#000'};
  position: relative;
`;

const PricingPrice = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: ${props => props.white ? 'white' : '#000'};
  display: flex;
  align-items: baseline;
`;

const PricingFeatures = styled.ul`
  list-style-type: none;
  margin-bottom: 2rem;
  flex: 1;
`;

const PricingFeature = styled.li`
  margin-bottom: 1rem;
  color: ${props => props.white ? 'rgba(255, 255, 255, 0.8)' : '#555'};
  display: flex;
  align-items: center;
  
  &:before {
    content: "";
    width: 18px;
    height: 18px;
    margin-right: 10px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='18' height='18'%3E%3Cpath fill='${props => props.white ? '%23fff' : '%23000'}' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
  }
`;

const ActionButton = styled(motion.button)`
  width: 100%;
  background-color: ${props => props.white ? 'white' : '#000'};
  color: ${props => props.white ? '#000' : 'white'};
  border: none;
  padding: 0.9rem 2rem;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: auto;
  
  &:hover {
    background-color: ${props => props.white ? '#f2f2f2' : '#333'};
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const Pricing = () => {
  return (
    <Section id="pricing">
      <SectionTitle>Pricing</SectionTitle>
      <PricingGrid>
        <PricingCard
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <PricingTitle>Consultation</PricingTitle>
          <PricingPrice>FREE</PricingPrice>
          <PricingFeatures>
            <PricingFeature>30 - 60 minutes</PricingFeature>
            <PricingFeature>General advice</PricingFeature>
            <PricingFeature>General assessment</PricingFeature>
            <PricingFeature>Verbal documentation</PricingFeature>
          </PricingFeatures>
          <ActionButton whileHover={{ y: -5 }}>Book a consultation</ActionButton>
        </PricingCard>
        
        <PricingCard 
          featured
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <PricingTitle white>Collaboration</PricingTitle>
          <PricingPrice white>Depends on stage of the company</PricingPrice>
          <PricingFeatures>
            <PricingFeature white>Unlimited Projects</PricingFeature>
            <PricingFeature white>Spend & Time tracking</PricingFeature>
            <PricingFeature white>Expert Advice</PricingFeature>
            <PricingFeature white>In-depth Assessments</PricingFeature>
            <PricingFeature white>Proactive Advice</PricingFeature>
            <PricingFeature white>Written documentation</PricingFeature>
          </PricingFeatures>
          <ActionButton white whileHover={{ y: -5 }}>Contact us</ActionButton>
        </PricingCard>
      </PricingGrid>
    </Section>
  );
};

export default Pricing; 